<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" icon>
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">{{ titleComputed }}</span>
            </v-card-title>
            <v-card-subtitle class="text-left mt-2">
                <span>부모: {{ item.canonicalName || "Root" }}</span>
            </v-card-subtitle>
            <v-card-text>
                <v-container>
                    <v-row class="mb-5">
                        <v-select
                                v-model="requestBody.type"
                                :items="['NODE', 'BOOK']"
                                label="타입"
                                hide-details
                                outlined></v-select>
                    </v-row>
                    <v-row class="mb-5">
                        <v-text-field
                                :disabled="requestBody.type !== 'BOOK'"
                                v-model="requestBody.mappingInformation"
                                label="매핑정보(TYPE BOOK ONLY)"
                                placeholder="이 필드는 자유롭습니다. 클라이언트에 맞춰서 필요한 정보를 입력해주세요."
                                hide-details outlined></v-text-field>
                    </v-row>
                    <v-row class="mb-5">
                        <v-text-field
                                v-model="requestBody.name"
                                label="매뉴얼 키(유니크키)"
                                placeholder="영문자(-대쉬 허용)만 가능하며 2~50자까지 설정할 수 있습니다."
                                hide-details outlined></v-text-field>
                    </v-row>
                    <v-row class="mb-5">
                        <v-text-field
                                v-model="requestBody.title"
                                label="매뉴얼 타이틀(번역키)"
                                placeholder="번역키로 사용할 매뉴얼 제목입니다."
                                hide-details outlined></v-text-field>
                    </v-row>
                    <v-row>
                        <v-textarea
                                v-model="requestBody.description"
                                label="매뉴얼설명"
                                rows="5" hide-details outlined></v-textarea>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">닫기</v-btn>
                <v-btn color="blue darken-1" text @click="apply" :disabled="!valid || !validSort">추가</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {PATH} from "@/constants";
    import {ON_MANUAL_RECEIVED} from "@/framework/listeners/listeners";

    export default {
        name: "ManualAppendButton",
        props: {
            item: {
                type: Object,
                default: () => {},
            },
            sort: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                dialog: false,
                requestBody: {
                    name: null,
                    title: "",
                    mappingInformation: null,
                    description: null,
                    parentId: null,
                    sort: null,
                    type: null,
                }
            }
        },
        computed: {
            valid() {
                return /^[A-Z][A-Z-]{0,48}[A-Z]$/.test(this.requestBody.name) && !!this.requestBody.title && this.requestBody.title.trim() && this.requestBody.type;
            },

            titleComputed() {
                if (!this.validSort) return "잘못된 타입입니다. 개발자에게 문의하세요. SORT: " + this.sort;
                return "하위 매뉴얼 추가";
            },

            validSort() {
                return this.sort === 'PC' || this.sort === 'MOBILE';
            },
        },
        watch: {
            'requestBody.name'() {
                this.requestBody.name = this.requestBody.name.toUpperCase();
            },

            'requestBody.type'() {
                if (this.requestBody.type !== 'BOOK') {
                    this.requestBody.mappingInformation = null;
                }
            },
        },
        methods: {
            apply() {
                this.requestSave();
            },

            requestSave() {
                if (!this.valid || !this.validSort) return this.$alert("올바르지 않은 타입입니다.", this.sort);

                this.requestBody.parentId = this.item.id;
                this.requestBody.sort = this.sort;
                this.$requestWithOverlay(PATH.MANUAL.CREATE)
                    .setObject(this.requestBody)
                    .enqueue()
                    .then(res => {
                        this.notifyEvent(ON_MANUAL_RECEIVED);
                        this.dialog = false;
                    });
            },
        },
    }
</script>

<style scoped>

</style>